// $FlowFixMe

import { datadogLogs } from '@datadog/browser-logs';

function observeOnce(options, callback) {
  function disconnectAndCallback(entries) {
    observer.disconnect();
    callback(entries);
  }
  const observer = new PerformanceObserver(disconnectAndCallback);
  observer.observe(options);
}

function canSupportPerformanceNavigationTimingEvent() {
  return (
    window.PerformanceObserver &&
    PerformanceObserver.supportedEntryTypes !== undefined &&
    PerformanceObserver.supportedEntryTypes.indexOf('navigation') !== -1
  );
}

function computeRelativePerformanceTiming() {
  var memo = { entryType: 'navigation' };
  for (var key in performance.timing) {
    if (typeof value === 'number') {
      memo[key] =
        performance.timing[key] === 0
          ? 0
          : performance.timing[key] - performance.timing.navigationStart;
    }
  }
  return memo;
}

function onPerformanceGenerated(callback) {
  if (canSupportPerformanceNavigationTimingEvent()) {
    observeOnce({ entryTypes: ['navigation'] }, function(performanceTiming) {
      callback(performanceTiming.getEntries()[0].toJSON());
    });
  } else {
    // Send it a bit after the actual load event, so the "loadEventEnd" timing is accurate
    setTimeout(function() {
      callback(computeRelativePerformanceTiming());
    });
  }
}

function init() {
  if (!window.Datadog) {
    console.info(
      'Skipping Datadog.LogConfig setup: window.Datadog is not set.'
    );
  } else {
    datadogLogs.init({
      clientToken: window.Datadog.LogConfig.clientToken,
      forwardErrorsToLogs: false,
      sampleRate: 100,
      env: window.Datadog.LogConfig.env,
    });

    datadogLogs.setLoggerGlobalContext(window.Datadog.LogConfig.globalContext);

    onPerformanceGenerated(function(timingData) {
      datadogLogs.logger.log('Page Load Timing', { timing: timingData });
    });
  }
}

init();
